import axios from "axios";

const agentApi = axios.create({
  baseURL: process.env.REACT_APP_API_TOKEN,
});

export default agentApi;
